export const SERVICES = [
  {
    slug: "individual-therapy",
    name: "Individual Therapy",
    blurb:
      "Trauma-informed support for adults, adolescents and children experiencing trauma, anxiety, depression, grief, relationship difficulties or major life changes.",
    cta: "Individual Therapy",
  },
  {
    slug: "play-therapy",
    name: "Play Therapy",
    blurb:
      "Creative, play-based therapy that helps children express feelings, process experiences and build emotional skills. Funded privately, with a Medicare rebate, or through the NDIS.",
    cta: "Play Therapy",
  },
  {
    slug: "emdr",
    name: "EMDR Therapy",
    blurb:
      "A structured, evidence-based therapy that helps the brain reprocess traumatic memories — for trauma, anxiety, phobias, grief and more.",
    cta: "EMDR Therapy",
  },
  {
    slug: "couples-counselling",
    name: "Couples Counselling",
    blurb:
      "A supportive space for couples experiencing disconnection, conflict, infidelity, communication difficulties or intimacy concerns.",
    cta: "Couples Counselling",
  },
  {
    slug: "family-therapy",
    name: "Family Therapy",
    blurb:
      "Support for families navigating conflict, parenting challenges, separation, trauma, changing family roles or difficult relationships.",
    cta: "Family Therapy",
  },
  {
    slug: "veterans-defence",
    name: "Veterans and Defence Families",
    blurb:
      "Trauma-informed support for current and former ADF members, veterans, partners and families affected by service-related experiences.",
    cta: "Veteran Support",
  },
  {
    slug: "victims-assist",
    name: "NSW Victims Assist Therapy",
    blurb:
      "Counselling for people affected by violent crime in NSW — funded through Victims Services for approved applicants, with no out-of-pocket cost.",
    cta: "Victims Assist Therapy",
  },
  {
    slug: "ndis-behaviour-support",
    name: "NDIS Positive Behaviour Support",
    blurb:
      "Specialist Positive Behaviour Support focused on understanding behaviour, improving quality of life and strengthening the capacity of participants and their support networks.",
    cta: "NDIS Behaviour Support",
  },
  {
    slug: "family-law-reports",
    name: "Family Law Reports",
    blurb:
      "Independent family reports and parental capacity assessments for parents, legal practitioners and other family law professionals.",
    cta: "Family Law Reports",
  },
  {
    slug: "clinical-supervision",
    name: "Clinical Supervision",
    blurb:
      "Professional supervision for social workers — individual or group, tailored to your practice, from a proud AASW member.",
    cta: "Clinical Supervision",
  },
  {
    slug: "eap",
    name: "Employee Assistance Program",
    blurb:
      "Confidential counselling and wellbeing support for employees, funded by their employer — for work stress, personal challenges and everything in between.",
    cta: "Employee Assistance",
  },
];

export const CONTACT = {
  address: "Unit 12, 151 Cotlew Street, Ashmore QLD 4214",
  addressCanberra: "Room 6, 310 Thesiger Court, Deakin ACT 2600",
  email: "hello@eucalypttherapy.com.au",
  phone: "0417 508 502",
  phoneHref: "tel:+61417508502",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BOOKING_URL =
  "https://eucalypt-therapy.splose.com/online-booking/5623b454-fbdb-44d0-a9fc-422d32a758ae";

export const FAMILY_LAW_FORM_URL =
  "https://eucalypt-therapy.splose.com/public-form/dff043e2-a653-4792-80e6-e01974269ff1";

export const GENERAL_FORM_URL =
  "https://eucalypt-therapy.splose.com/public-form/6ad38468-b557-4155-a6f2-e8f3cbee04e8";
